(function () {
    'use strict';

    var $ = window.jQuery;

    function Search(options) {
        if (!options) {
            throw new Error('No options passed to SearchButton constructor');
        }
        this.options = $.extend({}, Search.defaults, options);
        this.container = this.options.container;
        this.$container = $(this.container);
        this.$searchLink = $(this.options.searchLink);
        this.$inputClass = $(this.options.inputClass);
        this.$closeButton = $(this.options.closeButton);
        this.setupSearch();
    }

    Search.prototype.setupSearch = function () {
        var $self = this;
        this.$searchLink.on('click', function () {
            $self.$container.addClass($self.options.searchingClass);
            $self.$inputClass.val('');
            $self.$inputClass.focus();
        });

        this.$closeButton.on('click', function () {
            $self.$container.removeClass($self.options.searchingClass);
        });
    };

    Search.defaults = {
        container: '#bordeaux-top-menu',
        searchingClass: "searching",
        searchLink: '.search-link',
        inputClass: '.search-input',
        closeButton: '.close-button'
    };

    window.Search = Search;
}())
;